export default "__VITE_ASSET__Bk9D7l2v__"